import * as React from 'react'
import { createRoot } from 'react-dom/client'

import '../../assets/stylesheets/application.css'

import App from '../src/App'

const container = document.getElementById('main')!
createRoot(container).render(<App />)
